import { render, staticRenderFns } from "./UniversityFilter.vue?vue&type=template&id=764e7b3a&"
import script from "./UniversityFilter.vue?vue&type=script&lang=js&"
export * from "./UniversityFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports